function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 9.17,
  cy: 8.521,
  r: 8.177,
  transform: "rotate(120 9.17 8.52)",
  fill: "#1A8E96"
});

function SvgGreenBullet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgGreenBullet;